<div class="embla">
    @if (totalSlides > 0) {
        <div class="emblaCounter">
            {{ currentSlide }}/{{ totalSlides }}
        </div>
    }
    <div class="emblaViewport h-100" emblaCarousel #embla>
        <div class="mt-10 emblaContainer">
            @if (images && images.length > 0) {
                @for (image of images; track image) {
                    <div class="emblaSlide mediaControl">
                        <img [src]="image" class="w-100" mat-card-image>
                    </div>
                }
            } @else if (posts && posts.length > 0) {
                @for (post of posts; track post) {
                    @if (post) {
                        <app-post-card
                                [hideActions]="false"
                                [hideAttachments]="true"
                                [hideMedia]="false"
                                [hidePoll]="true"
                                [post]="post"
                                [reducedContent]="false"
                                [showOpenInFeed]="true"
                                [showPinnedBadge]="false"
                                class="emblaSlide"
                        ></app-post-card>
                    }
                }
            }

        </div>
    </div>
    <div class="d-flex flex-row flex-space-between emblaArrows align-items-center">
        @if (emblaApi) {
            <button (click)="emblaApi.scrollPrev()"
                    [disabled]="!emblaApi?.canScrollPrev()"
                    [matTooltip]="'Previous Post'"
                    mat-icon-button>
                <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
        }
        <div #dotsNode id="emblaDots"></div>
        @if (emblaApi) {
            <button (click)="emblaApi.scrollNext()"
                    [disabled]="!emblaApi?.canScrollNext()"
                    [matTooltip]="'Next Post'"
                    mat-icon-button>
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        }
    </div>
</div>
